import React from "react";

const Kotlin_Inheritance = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Kotlin Inheritance</h1>
      <p>Content for Kotlin Inheritance goes here.</p>
    </div>
  );
};

export default Kotlin_Inheritance;
